<template>
  <Popup
    class="popup-wrap"
    v-model="openPopup"
    :round="true"
    :style="modalCss"
    @open="open"
    @close="close"
  >
    <div class="content">
      <img v-if="img" :src="img" alt="" />
      <slot v-else name="content"></slot>
    </div>
  </Popup>
</template>

<script>
import { Popup } from "vant";
export default {
  name: "GroupPurchaseWelfare",
  components: {
    Popup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      openPopup: false,
      modalCss: {
        width: "350px",
        'min-height': '300px',
        'max-height': "500px",
      },
    };
  },
  watch: {
    show(value) {
      this.openPopup = value;
    },
  },
  methods: {
    open() {
      this.$emit("update:show", true);
    },
    close() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
.popup-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content {
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: scroll;
}
.content > img {
  width: 100%;
  min-height: 300px;
  object-fit: contain;
}
</style>
